import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LanguageSelector.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LanguageSelector.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/navbar/LanguageSelector.vue?vue&type=script&lang=js
// module id = HraS
// module chunks = 41